import React, { Component } from 'react';
import type { ReactNode, ErrorInfo } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          width: '100vw', height: '100vh', background: '#0a0a0f', color: '#cfdcec',
          fontFamily: 'monospace', gap: 16,
        }}>
          <div style={{ fontSize: 18, fontWeight: 600 }}>Rendering Error</div>
          <div style={{ fontSize: 13, color: 'rgba(207,220,236,.55)', maxWidth: 500, textAlign: 'center' }}>
            {this.state.error?.message ?? 'An unexpected error occurred in the 3D renderer.'}
          </div>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              appearance: 'none', border: '1px solid rgba(120,160,210,.18)',
              background: 'transparent', color: '#4cc9f0', padding: '8px 20px',
              borderRadius: 6, cursor: 'pointer', fontSize: 13, fontFamily: 'inherit',
            }}
          >Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
